import { useMutation, useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';
// ────────────────────────────────────────────────────────────────────────────
// Mutation : create
// ────────────────────────────────────────────────────────────────────────────
export function useCreateShareableScore() {
    return useMutation({
        mutationFn: async (input) => {
            const { data, error } = await supabase.rpc('create_shareable_score', {
                p_game_type: input.gameType,
                p_score: input.score,
                p_score_meta: (input.meta ?? {}),
                p_source_score_id: input.sourceScoreId,
            });
            if (error)
                throw error;
            if (!data)
                throw new Error('create_shareable_score returned no id');
            return data;
        },
    });
}
// ────────────────────────────────────────────────────────────────────────────
// Query : public read (page /score/:id)
// ────────────────────────────────────────────────────────────────────────────
export function useShareableScore(id) {
    return useQuery({
        queryKey: ['shareable-score', id ?? 'none'],
        enabled: !!id,
        queryFn: async () => {
            if (!id)
                return null;
            const { data, error } = await supabase.rpc('get_shareable_score', { p_id: id });
            if (error)
                throw error;
            const row = Array.isArray(data) ? data[0] : data;
            if (!row)
                return null;
            return {
                id: row.id,
                player_id: row.player_id,
                pseudo: row.pseudo,
                avatar_url: row.avatar_url,
                level: row.level,
                game_type: row.game_type,
                score: row.score,
                score_meta: (row.score_meta ?? {}),
                image_url: row.image_url,
                view_count: row.view_count,
                created_at: row.created_at,
            };
        },
        staleTime: 30_000,
    });
}
// ────────────────────────────────────────────────────────────────────────────
// Helper : URL publique de partage
// ────────────────────────────────────────────────────────────────────────────
export function shareUrl(id) {
    // En prod cette base passera par VITE_APP_URL ; en dev on suit l'origine.
    const base = import.meta.env.VITE_APP_URL ?? window.location.origin;
    return `${base}/score/${id}`;
}
